import Button from "../../Common/Button/Button";
import CopyBlock from "../../Common/CopyBlock/CopyBlock";
import promptStyle from "../prompt.module.css";

import burpLogo from "../../../assets/BurpLogo.png"
import cliLogo from "../../../assets/TerminalLogo.png"

interface Props {
  advance: () => void;
}
function InstallationGuide({ advance }: Readonly<Props>) {
  const command = "curl -sL https://raw.githubusercontent.com/Pentra-Solutions/rel_logger/main/install.sh | bash";

  return (
    <div className={promptStyle.loneTextWrapper + " " + promptStyle.leftAlign}>
      <div className={promptStyle.confirmButton}>
        <h3 className={promptStyle.title}>Logger Setup</h3>
        <Button
          onClick={() => {
            advance();
            console.log("Solved Logger Installation");
          }}
          variant="secondary"
          color="blue"
        >
          I'm all set up!
        </Button>
      </div>
      <div className={promptStyle.promptCard}>
        <img src={cliLogo} className={promptStyle.burpLogo} alt={"Burp Logo"} />
        <p className={promptStyle.text}>
          To link your terminal to the Pentra interface, download our logger <span className={promptStyle.blueText}>with this command</span>:
        </p>
        <CopyBlock text={command} />

        <br />
        <br />
        <br />
        <img src={burpLogo} className={promptStyle.burpLogo} alt={"Burp Logo"} />
        <p className={promptStyle.text}>
          To set up the Burp Integration visit the <span className={promptStyle.blueText}>Installations</span> page after the tutorial.
        </p>

        <p className={promptStyle.note}>
          <span className={promptStyle.blueText}>Note:</span> Currently, the Pentra Logger is supported on all linux
          distributions and virtual machines. However, it can't run inside a Docker container, and isn't supportend on
          Windows (with WSL) or MacOS either. If you would like to see such a version in the future, send us a message
          at <span className={promptStyle.blueText}>support@pentra.ai</span> to tell us about your use case!
        </p>

      </div>
    </div>
  );
}

export default InstallationGuide;
